module.exports = __webpack_public_path__ + "img/affiliate.6e8b1d26.jpg";